import { render, staticRenderFns } from "./CustomSkeleton.vue?vue&type=template&id=5fdf4437&scoped=true&"
import script from "./CustomSkeleton.vue?vue&type=script&lang=js&"
export * from "./CustomSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CustomSkeleton.vue?vue&type=style&index=0&id=5fdf4437&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdf4437",
  null
  
)

export default component.exports